import type { IItem } from '../types/interfaces';
import { getOfficerDisplayLabel } from './officerDisplay';

type OfficerOption = Readonly<{ code: string; label: string }>;

/**
 * Patrón A (listados): celda derivada del oficial de cartera (`officer` + catálogo).
 * Con selección por gerencia activa, usa `management_label` del listado.
 */
function listManagementLabel(item: IItem): string | undefined {
  const r = item as IItem & { managementLabel?: string | null };
  const v = item.management_label ?? r.managementLabel;
  const t = v?.trim();
  return t || undefined;
}

export function commercialCellFromOfficerPath(
  item: IItem,
  officers: ReadonlyArray<OfficerOption>,
  isManagementSelectionEnabled: boolean,
): string {
  if (isManagementSelectionEnabled) {
    const label = listManagementLabel(item);
    if (label) return label;
    return 'Sin asignar';
  }
  const officerRaw = (item as IItem & { officer?: string }).officer;
  if (!officerRaw || officerRaw === '-') return 'Sin asignar';
  const label = getOfficerDisplayLabel(officerRaw, officers);
  return label === '—' ? 'Sin asignar' : label;
}

/** Patrón B: empleado comercial en `item.commercial` (sin cambiar por flag gerencia). */
export function commercialCellFromCommercialEmployee(item: IItem): string {
  return item.commercial
    ? `${item.commercial.first_name} ${item.commercial.last_name}`.trim()
    : 'Sin asignar';
}
